import type { AxfoodCartViewModel, AxfoodStoreInfoViewModel } from '@occ/api-client';
import Config from '@config';

import DeliveryModeCode from '@enums/DeliveryModeCode';

interface Props {
  deliveryModeCode: DeliveryModeCode;
  store: AxfoodStoreInfoViewModel;
  cart: AxfoodCartViewModel;
}

export const getDeliveryAddress = ({ deliveryModeCode, store, cart }: Props) => {
  let address = null;

  if (deliveryModeCode === Config.HOME_DELIVERY && cart.deliveryAddress) {
    const { line1, postalCode, town } = cart.deliveryAddress;
    const street = line1 ? `${line1}, ` : '';
    address = {
      line1: `${street}${postalCode} ${town}`,
    };

    // if we toggle back to non tms solution and don't have postal code we should set address to null and show select address view
    if (!postalCode) {
      address = null;
    }
  }

  if (deliveryModeCode === Config.PICKUP_IN_STORE) {
    address = {
      line1: store?.name || '',
      line2: `${store?.address?.line1}, ${store?.address?.town}, ${store?.address?.postalCode}`,
    };
  }

  return address;
};
